import React from 'react'

const Icon = () => {
  return (
    <svg
      fill='none'
      viewBox='0 0 26 26'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.922 8.213a1.873 1.873 0 001.065 2.571l1.265.45a1.875 1.875 0 010 3.534l-1.265.45a1.874 1.874 0 00-1.065 2.571L21.5 19a1.876 1.876 0 01-2.5 2.5l-1.213-.576a1.874 1.874 0 00-2.571 1.065l-.45 1.265a1.875 1.875 0 01-3.533 0l-.45-1.265a1.874 1.874 0 00-2.572-1.065L7 21.5A1.873 1.873 0 014.5 19l.576-1.213a1.874 1.874 0 00-1.065-2.571l-1.265-.45a1.875 1.875 0 010-3.534l1.265-.45a1.874 1.874 0 001.065-2.569L4.5 7A1.874 1.874 0 017 4.5l1.213.576a1.875 1.875 0 002.57-1.063l.45-1.265a1.875 1.875 0 013.533 0l.45 1.265a1.873 1.873 0 002.571 1.065L19 4.5A1.875 1.875 0 0121.5 7l-.578 1.213z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M12.999 17.501a4.5 4.5 0 100-9 4.5 4.5 0 000 9z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Icon
